interface Config {
  dashboardBaseUrl: string;
  pivotUrl: string;
  auth0Domain: string;
  auth0ClientId: string;
  auth0Audience: string;
}

const auth0 = {
  auth0Domain: "remerge.eu.auth0.com",
  auth0ClientId: "rxRTwMZCpjd4fXOmEfHCjT4uSlQmcBp7",
  auth0Audience: "https://api.remerge.io",
};

const devConfig: Config = {
  dashboardBaseUrl: "https://ua.remerge.test:3080",
  pivotUrl: "https://pivot.remerge.test:8080",
  ...auth0,
};

const productionConfig: Config = {
  dashboardBaseUrl: "https://ua.remerge.io",
  pivotUrl: "https://pivot.remerge.io",
  ...auth0,
};

export function config(): Config {
  if (process.env.NODE_ENV === "production") {
    return productionConfig;
  }
  return devConfig;
}
